import axios from "axios";
import { API_ROUTE, encodePathValue, headersRequest } from "../../../helpers";

export const CustomViewsServices = {
  getViewsByOrganzation: async () => {
    try {
      const result = await axios.get(
        `${API_ROUTE}views-gantt`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("Error al cargar los datos");
    }
  },
  deleteView: async (IdCalendar) => {
    try {
      const safeCalendarId = encodePathValue(IdCalendar);
      const result = await axios.delete(
        `${API_ROUTE}views-gantt/${safeCalendarId}`,
        headersRequest()
      );
      if (result.status == 200) {
        return result;
      }
    } catch (error) {
      throw new Error("error al eliminar la vista");
    }
  },
  getOneView: async (IdView) => {
    try {
      const safeViewId = encodePathValue(IdView);
      const result = await axios.get(
        `${API_ROUTE}views-gantt/${safeViewId}`,
        headersRequest()
      );
      if (result.status == 200) {
        return result.data;
      }
    } catch (error) {
      throw new Error("error al traer la vista");
    }
  },
  createView: async (data) => {
    try {
      const result = await axios.post(
        `${API_ROUTE}views-gantt`,
        data,
        headersRequest()
      );
      if (result.status == 200) {
        return result;
      }
    } catch (error) {
      throw new Error("error al crear el vista");
    }
  },
  updateView: async (data) => {
    try {
      const safeViewId = encodePathValue(data.idView);
      const result = await axios.put(
        `${API_ROUTE}views-gantt/${safeViewId}`,
        data,
        headersRequest()
      );
      if (result.status == 200) {
        return result;
      }
    } catch (error) {
      throw new Error("error al actualizar la vista");
    }
  },
  initialStatelabels: [
    { index: 0, label: "WBS", value: "hideWbs" },
    { index: 1, label: "Actividad", value: "hideTask" },
    { index: 2, label: "Fecha inicio", value: "hideStart" },
    { index: 3, label: "Fecha fin", value: "hideEnd" },
    { index: 4, label: "Duración", value: "hideDuration" },
    { index: 5, label: "Duración (hrs)", value: "hideDuration_hrs" },
    { index: 6, label: "Esfuerzo LB1", value: "hidePlanEffort" }, // Nuevo campo agregado primero
    { index: 7, label: "Esfuerzo Real", value: "hideRealEffort" }, // Nuevo campo agregado después
    { index: 8, label: "UID", value: "hideUnique" },
    { index: 9, label: "Costo", value: "hideCost" },
    { index: 10, label: "Costo Real", value: "hideCostReal" },
    { index: 11, label: "Predecesora", value: "hidePrede" },
    { index: 12, label: "Sucesora", value: "hideSuccessors" },
    { index: 13, label: "% Real", value: "hideReal" },
    { index: 14, label: "% Plan.", value: "hidePlan" },
    { index: 15, label: "Indicador", value: "hideIndi" },
    { index: 16, label: "Fecha Inicio LB1", value: "hideLB_start_1" },
    { index: 17, label: "Fecha Fin LB1", value: "hideLB_end_1" },
    { index: 18, label: "Duración LB1", value: "hideLB_duration_1" },
    { index: 19, label: "Costo LB1", value: "hideLB_cost_1" },
    { index: 20, label: "Fecha Inicio LB2", value: "hideLB_start_2" },
    { index: 21, label: "Fecha Fin LB2", value: "hideLB_end_2" },
    { index: 22, label: "Duración LB2", value: "hideLB_duration_2" },
    { index: 23, label: "Costo LB2", value: "hideLB_cost_2" },
    { index: 24, label: "Fecha Inicio LB3", value: "hideLB_start_3" },
    { index: 25, label: "Fecha Fin LB3", value: "hideLB_end_3" },
    { index: 26, label: "Duración LB3", value: "hideLB_duration_3" },
    { index: 27, label: "Costo LB3", value: "hideLB_cost_3" },
    { index: 28, label: "Fecha Inicio LB4", value: "hideLB_start_4" },
    { index: 29, label: "Fecha Fin LB4", value: "hideLB_end_4" },
    { index: 30, label: "Duración LB4", value: "hideLB_duration_4" },
    { index: 31, label: "Costo LB4", value: "hideLB_cost_4" },
    { index: 32, label: "Fecha Inicio LB5", value: "hideLB_start_5" },
    { index: 33, label: "Fecha Fin LB5", value: "hideLB_end_5" },
    { index: 34, label: "Duración LB5", value: "hideLB_duration_5" },
    { index: 35, label: "Costo LB5", value: "hideLB_cost_5" },
  ],

   InitialStateColumns: {
    hideWbs: [false, 0],
    hideTask: [false, 1],
    hideStart: [false, 2],
    hideEnd: [false, 3],
    hideDuration: [false, 4],
    hideDuration_hrs: [false, 5],
    hidePlanEffort: [false, 6],
    hideRealEffort: [false, 7],
    hideUnique: [false, 8],
    hideCost: [false, 9],
    hideCostReal: [false, 10],
    hidePrede: [false, 11],
    hideSuccessors: [false, 12],
    hideReal: [false, 13],
    hidePlan: [false, 14],
    hideIndi: [false, 15],
    hideLB_start_1: [false, 16],
    hideLB_end_1: [false, 17],
    hideLB_duration_1: [false, 18],
    hideLB_cost_1: [false, 19],
    hideLB_start_2: [false, 20],
    hideLB_end_2: [false, 21],
    hideLB_duration_2: [false, 22],
    hideLB_cost_2: [false, 23],
    hideLB_start_3: [false, 24],
    hideLB_end_3: [false, 25],
    hideLB_duration_3: [false, 26],
    hideLB_cost_3: [false, 27],
    hideLB_start_4: [false, 28],
    hideLB_end_4: [false, 29],
    hideLB_duration_4: [false, 30],
    hideLB_cost_4: [false, 31],
    hideLB_start_5: [false, 32],
    hideLB_end_5: [false, 33],
    hideLB_duration_5: [false, 34],
    hideLB_cost_5: [false, 35],
  }

};
